import { Component, ViewChild, inject } from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'
import { Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { UntilDestroy } from '@ngneat/until-destroy'
import { map } from 'rxjs/operators'
import {
  AnnouncementsState,
  GetMyAnnouncements,
  IAnnouncementItem
} from '@lla-platform/announcements/announcements-data-access'
import { environment } from '@lla-platform/core/core-util'

const MAX_PANEL_ITEMS = 20

@UntilDestroy()
@Component({
  selector: 'lla-announcements-menu',
  templateUrl: './announcements-menu.component.html',
  styleUrls: ['./announcements-menu.component.scss'],
  standalone: false
})
export class AnnouncementsMenuComponent {
  protected isProduction = environment.production
  announcements$ = inject(Store).select(AnnouncementsState.announcements)
  unreadCount$ = inject(Store).select(AnnouncementsState.unreadCount)

  protected visibleAnnouncements$ = this.announcements$.pipe(
    map((items) => items?.filter((q) => !q.archivedDate && !q.readDate).slice(0, MAX_PANEL_ITEMS))
  )

  @ViewChild(MatMenuTrigger) private menuTrigger?: MatMenuTrigger

  constructor(
    private store: Store,
    private router: Router
  ) {}

  protected menuOpened() {
    this.store.dispatch(new GetMyAnnouncements())
  }

  protected openItem(item: IAnnouncementItem) {
    this.menuTrigger?.closeMenu()
    this.router.navigate(['/announcements', item.announcementId])
  }

  protected viewAll() {
    this.menuTrigger?.closeMenu()
    this.router.navigate(['/announcements'])
  }
}
